import styleConfig from '../../muiTheme';

const styles = {
  loaderStyle: {
    height: '80px',
    width: '80px',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    msFlexDirection: 'column',
    msJustifyContent: 'center',
    msAlignItems: 'center',
  },
  labelLoadingStyle: {
    fontSize: '12px',
    color: styleConfig.palette.gray9A,
    margin: '5px 0 0 0',
    padding: '0',
  },
};

export default styles;
